import { render, staticRenderFns } from "./input-select.vue?vue&type=template&id=3540e29e&scoped=true&"
import script from "./input-select.vue?vue&type=script&lang=js&"
export * from "./input-select.vue?vue&type=script&lang=js&"
import style0 from "./input-select.vue?vue&type=style&index=0&id=3540e29e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3540e29e",
  null
  
)

export default component.exports